import { Image } from '../../models/Image'
import { Icon } from '../Icon'

type Props = { fallbackIcon: React.ComponentProps<typeof Icon>; className?: string; image?: Image }

export const ImageView = ({ fallbackIcon, className, image }: Props) => {
    if (image && Boolean(image.uri)) {
        return <img src={image.uri} alt={image.name} className={className} />
    }

    return <Icon {...fallbackIcon} />
}
